<template>
  <div>
    <div class="tips clearfix">
      <div class="containers">
        <div class="people clearfix fl">
          <div class="pic">
            <img :src="userinfo.avatar" alt srcset />
          </div>
          <div class="infos">
            <div class="name">{{userinfo.nick}}</div>
            <div class="phones">{{userinfo.phone}}</div>
          </div>
        </div>
        <div class="spanbox fr">
          <router-link tag="span" to="/follow/followteachers">
            我的关注
            <i>{{userinfo.teacherCollection}}</i>
          </router-link>
          <span @click="jumps('1')">
            我的收藏
            <i>{{userinfo.videoCollection }}</i>
          </span>
          <span @click="jumps('0')">
            我的课程
            <i>{{userinfo.myVideo}}</i>
          </span>
        </div>
      </div>
    </div>
    <div style='height:110px'></div>
  </div>
</template>

<script>
import utilFile from "@/ace/ace.js";
export default {
  data() {
    return {
      userinfo: {} //登录信息
    };
  },
  inject: ["reload"], // 引入方法
  methods: {
    user() {
      this.$axios({
        method: "post",
        url: `/api/user.infomation`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.isLogin = false;
        } else {
          let userinfo = JSON.parse(utilFile.decrypt(res.data.data));
          this.userinfo = userinfo;
          this.isLogin = true;
        }
      });
    },
    jumps(index) {
      if (index == 1) {
        this.$router.push({
          path: "/course/soncollection",
          query: { index: index }
        });
      }else{
        this.$router.push({
          path: "/course/soncourse",
          query: { index: index }
        });
      }
      this.reload();
    }
  },
  mounted() {
    this.user();
  }
};
</script>

<style scoped>
@import "~@/assets/css/my.css";
</style>